import { ButtonLink } from "@ui/ButtonLink";
import { Card } from "@ui/Card";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";
import { hasNoCreditsLeft } from "~/modules/shared/utils/useMeteringBalance";

export const BillingCreditsBalance = () => {
	return (
		<Show when={hasNoCreditsLeft()}>
			<Card theme="orange">
				<HStack justify="space-between" align="center" spacing="medium">
					<HStack spacing="medium" align="center">
						<MaterialSymbol symbol="toll" relativeSize={1.75} color="warning" />
						<VStack>
							<Text weight="bold">You're out of credits</Text>
							<Text color="fg3" size="small">
								You've used all of this cycle's credits - top up now, wait for
								your next reset or upgrade to a paid plan
							</Text>
						</VStack>
					</HStack>
					<HStack spacing="medium" align="center" justify="center">
						<ButtonLink
							theme="orange"
							variant="secondary"
							symbol="arrow_downward"
							href="/account/plans?topup=true&topup_category=credits"
						>
							Top up
						</ButtonLink>
						<ButtonLink
							theme="orange"
							variant="secondary"
							symbol="arrow_upward"
							href="/account/plans"
						>
							Upgrade
						</ButtonLink>
					</HStack>
				</HStack>
			</Card>
		</Show>
	);
};
